import View from '~/app/View'

// Headers
import ImageNavigation from '~/components/collection/image-navigation'

// Filter
import FilterDrawer from '~/components/collection/filter-drawer'
import FilterCategory from '~/components/collection/filter-category'
import FilterSort from '~/components/collection/filter-sort'

// Product grid
import ProductGrid from '~/components/collection/product-grid'

import '@/templates/collection.scss'

const collectionView = new View()
collectionView.init({
  ImageNavigation,
  FilterDrawer,
  FilterCategory,
  FilterSort,
  ProductGrid,
})
